<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>合作玩法统计</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="类型" prop="endDate">
        <el-select
          v-model.number="queryParams.type"
          placeholder="请选择类型"
          size="small"
          @keyup.enter.native="handleQuery"
        >
          <el-option
            v-for="(item, index) in typeArr"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button type="success" size="mini" :loading="loading" icon="el-icon-search" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >

      <el-table-column
        prop="date"
        label="日期"
        align="center"
      />
      <el-table-column
        prop="user"
        label="参与人数"
        align="center"
      />
      <el-table-column
        label="阶段人数"
        align="center"
      >
        <el-table-column
          v-for="(item, index) in [1,2,3,4,5,6,7,8,9]"
          :key="index"
          :label="'阶段'+item"
          align="center"
        >
          <template v-slot:default="{row}">
            <span v-if="row.progress_user[index]">{{ row.progress_user[index] }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="max_reward_user"
        label="完成人数"
        align="center"
      />
      <el-table-column
        label="总消耗代币"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="320"
            trigger="hover"
            content="完成所有建造 消耗的"
          >
            <span slot="reference">总消耗代币 <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template v-slot:default="scope">
          <span>{{ scope.row.currency_num }}</span>
        </template>
      </el-table-column>
    </el-table>

    <totalStat ref="ad" title="代币来源数量" />
    <totalStat ref="ad2" title="代币来源人均数量" />
  </el-card>
</template>

<script>
import { getCooperativeTreasureStat } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import totalStat from '@/views/config/cooperative-build-stat/components/echart.vue'

export default {
  name: 'CooperativeTreasureStat',
  components: {
    totalStat
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      },
      typeArr: [{ label: '天', value: 0 }, { label: '总', value: 1 }],
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.level = 0
      this.tableData = []
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getCooperativeTreasureStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        this.tableData = res.data.data
        this.$refs.ad.refresh(this.tableData, res.data.rid, 'num')
        this.$refs.ad2.refresh(this.tableData, res.data.rid, 'avg')
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.level = 1
      getCooperativeTreasureStat(this.queryParams).then(res => {
        this.loading = false
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
